import { createContext } from "react";

const RewardsContext = createContext();

export default RewardsContext;
